import { IconName } from '@billy/design-system'

import { BillBalanceModifierReference } from '@features/bills/enums/BillBalanceModifierReference'

export const billBalanceModifierReferenceToIconName: Record<BillBalanceModifierReference, IconName> = {
  [BillBalanceModifierReference.BankPayment]: 'bank',
  [BillBalanceModifierReference.Bill]: 'receiptText',
  [BillBalanceModifierReference.ContactBalancePayment]: 'creditCard',
  [BillBalanceModifierReference.DaybookTransaction]: 'bank',
}
